const viewSizes = {
  SMALL: 0,
  MEDIUM: 576,
  LARGE: 992,
  EXTRA_LARGE: 1200
};
export const egenciaViewportContext = {
  /**
   * Determines the valid Viewport component to render.
   */
  validViewSize: viewSizes.SMALL,
  /**
   * Function for setting a new ValidViewSize in the context.
   */
  setValidViewSize: (number) => {
    egenciaViewportContext.validViewSize = number;
  },
  /**
   * Either client defined pixel definitions for each View Size or
   * the default values.
   */
  viewSizes,
  /**
   * Used to account for the base font size when determining breakpoints.
   */
  baseFontSizePx: 11,
  getViewSize: function() {
    return Object.keys(viewSizes).find((key) => this.viewSizes[key] === this.validViewSize);
  }
};
